/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Library_Example_PaperInputs */

const en_mcp_cap_library_example_paper = /** @type {(inputs: Mcp_Cap_Library_Example_PaperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Research paper`)
};

const es_mcp_cap_library_example_paper = /** @type {(inputs: Mcp_Cap_Library_Example_PaperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículo de investigación`)
};

/**
* | output |
* | --- |
* | "Research paper" |
*
* @param {Mcp_Cap_Library_Example_PaperInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_library_example_paper = /** @type {((inputs?: Mcp_Cap_Library_Example_PaperInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Library_Example_PaperInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_library_example_paper(inputs)
	return en_mcp_cap_library_example_paper(inputs)
});